const SIZES = 'size-medium';
const FONTS_SIZES = 'small';
const FONT_SIZES_SM = 'sm-small';
const FONT_SIZES_MD = 'md-small';
const FONT_SIZES_LG = 'lg-small';
const MODAL_SIZES = 'leal-modal-lg';

export { FONTS_SIZES as F, MODAL_SIZES as M, SIZES as S, FONT_SIZES_SM as a, FONT_SIZES_MD as b, FONT_SIZES_LG as c };
